import * as React from 'react';
import { Typography } from '@/components/common';
import { AdvertisingRoiresult } from '@/interfaces';

export const CaseMetricsAdvertisingROI = ({
	advertisingROI,
}: {
	advertisingROI: AdvertisingRoiresult[];
}) => {
	return (
		<div className="grid  px-4 grid-cols-1 lg:grid-cols-2 gap-3 lg:px-0 lg:gap-12">
			<div className="grid grid-cols-1 border-b pb-3 border-grey-100 lg:pb-0 lg:border-b-0 lg:border-r">
				<Typography
					type="semibold-16"
					className="text-grey-80 mb-1 text-center !text-[16px] !leading-[19.2px]"
				>
					Cost per Acquisition
				</Typography>
				<Typography
					type="semibold-28"
					className="text-grey-90 text-center !text-[28px] !leading-[33.6px]"
				>
					${advertisingROI[0]?.cost_per_acquisition || '0'}
				</Typography>
			</div>
			<div className="grid grid-cols-1">
				<Typography
					type="semibold-16"
					className="text-grey-80  mb-1 text-center !text-[16px] !leading-[19.2px]"
				>
					Claim Acceptance Rate <br />
					<span className="text-[10px] text-grey-50 font-semibold">
						(Submitted to Eligible)
					</span>
				</Typography>
				<Typography
					type="semibold-28"
					className="text-grey-90 text-center !text-[28px] !leading-[33.6px]"
				>
					{advertisingROI[0]?.conversion_rate || '0'}%
				</Typography>
			</div>
		</div>
	);
};
